import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import type { Lodging } from "@b2bportal/lodging-api";
import { HotelShopPrice } from "@tenant/hotels";
import clsx from "clsx";
import { useHotelShopBookingSection } from "./hooks";
import defaultStyles from "./HotelShopBookingSection.module.scss";
import { scrollToElement } from "@/utils/scroll";

export interface HotelShopBookingSectionProps extends PlatformComponentProps {
  hotel: Lodging;
  goToNextStep: () => void;
}

const COMPONENT_KEY = CoreHotelsComponent.HotelShopBookingSection;

export const HotelShopBookingSection = (
  props: HotelShopBookingSectionProps
) => {
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { className } = props;

  const viewProps = useHotelShopBookingSection(props);

  const handleChooseRoom = () => {
    scrollToElement("rooms");
  };

  return (
    <div className={clsx(block, className)}>
      <HotelShopPrice
        className={cn("price-container")}
        hotel={viewProps.hotel}
      />

      <button
        disabled={viewProps.nextStep == null}
        className={cn("button")}
        onClick={handleChooseRoom}
      >
        {viewProps.text.roomCTA}
      </button>
    </div>
  );
};
